module.exports = __webpack_public_path__ + "50951490b3c71bed644f5b56ae3539f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/33.jpg
// module id = 1361
// module chunks = 47